export default __webpack_public_path__ + "static/bannerPubliMB-AR-8b7d900030947012668547e55957ed5b.png";